import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Text from '@zenbusiness/common-components/Text';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const StyledSharedAsset = styled(SharedAsset)({
  marginRight: '0.5rem',
  objectFit: 'contain'
});

const StyledText = styled(Text)({
  textTransform: 'inherit',
  color: 'inherit'
});

export const BubbleContent = ({
  title, text, image, selected
}) => (
  <Box display="flex">
    {image && (
      <StyledSharedAsset
        src={image}
        alt="bubble-image"
      />
    )}
    <Box textAlign="left">
      {title && <StyledText size="md" bold className={classNames(selected && 'selected')}>{title}</StyledText>}
      <StyledText size="md" className={classNames(selected && 'selected')}>{text}</StyledText>
    </Box>
  </Box>
);

BubbleContent.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.string,
  selected: PropTypes.bool
};

BubbleContent.defaultProps = {
  title: null,
  text: '',
  image: null,
  selected: false
};
